<!--
 Description: 数据模拟表 List
 Author: 作者
 Date:   2021-09-15
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="add" type="primary" icon="plus">新增</a-button>
    </div>

    <!-- table区域-begin -->
    <div>


      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="editData(record)">编辑数据</a>
          <a-divider type="vertical" />
          <a-popconfirm title="更新为实际数据,确定更新吗?" @confirm="() => gxsj(record)">
            <a>更新数据</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleEdit(record)">编辑</a>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>

        <span slot="qymnsj" slot-scope="text, record">
          <a-switch v-if="record.useStatus=='0'" checked-children="启用" un-checked-children="停用"  @change="qy(record.id)" />
          <a-switch  v-else default-checked checked-children="启用" un-checked-children="停用"  @change="ty(record.id)" />
        </span>

        <span slot="rowIndex" slot-scope="text, record, index">
          {{(ipagination.current-1)*ipagination.pageSize+index+1}}
        </span>

      </a-table>
    </div>

    <sys-api-mock-modal ref="modalForm" @ok="modalFormOk"></sys-api-mock-modal>

    <sys-api-mock-data-list-modal ref="modalFormDataList" @ok="modalFormDataListOk"></sys-api-mock-data-list-modal>
  </a-card>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import SysApiMockModal from './modules/SysApiMockModal__Style#Drawer'
  import SysApiMockDataListModal from './modules/SysApiMockDataListModal__Style#Drawer'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'SysApiMockListlist',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JDictSelectTag,
      SysApiMockModal,SysApiMockDataListModal
    },
    data () {
      return {
        description: '数据模拟表管理页面',
        // 表头
        columns: [
          {
            title:'模块名',
            align:"center",
            dataIndex: 'mockName'
          },
          {
            title:'模块编号',
            align:"center",
            dataIndex: 'mockCode'
          },
          {
            title:'组装数据的DTO类名',
            align:"center",
            dataIndex: 'mockDto'
          },
          {
            title:'生产数据查询接口',
            align:"center",
            dataIndex: 'mockUrl'
          },
          {
            title:'生产数据查询接口类型',
            align:"center",
            dataIndex: 'mockUrlType_dictText'
          },
          {
            title:'使用状态',
            align:"center",
            dataIndex: 'useStatus_dictText'
          },
          {
            title: '启用模拟数据',
            dataIndex: 'qymnsj',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'qymnsj' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:240,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/sys/sysapimock/page",
          delete: "/sys/sysapimock/delete",
          deleteBatch: "/sys/sysapimock/delete/batch",
          exportXlsUrl: "/sys/sysapimock/export/xls",
          importExcelUrl: "sys/sysapimock/import/excel",
          gxsj: "/sys/sysapimock/gxsj-list",
          qy: "/sys/sysapimock/qy",
          ty: "/sys/sysapimock/ty",
          
        },
        dictOptions:{},
        bigdataId:null,
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      gxsj(record){
        let that = this;
        if(record.useStatus=="0"){
          
          httpAction(record.mockUrl,{},record.mockUrlType).then((res)=>{
            if(res.success){
                let param = {};
                param.id=record.id;
                param.mockDataObj=res.result;
                httpAction(this.url.gxsj,param,'post').then((res)=>{
                  if(res.success){
                      that.$message.success(res.message);
                  }else{
                      that.$message.warning(res.message);
                  }
                })
            }
          })
        }else{
          that.$message.warning("请先停用再更新数据！");
          return false;
        }
      },
      qy(id){
        let that = this;
        getAction(that.url.qy, {id: id}).then((res) => {
          if(res.success){
              that.$message.success(res.message);
              that.loadData();
          }else{
              that.$message.warning(res.message);
          }
        })
      },
      ty(id){
        let that = this;
        getAction(that.url.ty, {id: id}).then((res) => {
          if(res.success){
              that.$message.success(res.message);
              that.loadData();
          }else{
              that.$message.warning(res.message);
          }
        })
      },
      editData(record){
        
        this.$refs.modalFormDataList.edit(record);
        this.$refs.modalFormDataList.title="编辑数据";
        this.$refs.modalFormDataList.disableSubmit = false;
        
      },
      getOrderMain(bigdataId) {
        this.queryParam.mockDataType = "02";
        this.queryParam.bigdataId = bigdataId;
        this.bigdataId = bigdataId;
        this.loadData(1);
      },
      add(){
        if(this.bigdataId==null){
          this.$message.warning("请先选择一条数据!");
          return false;
        }
        this.$refs.modalForm.add(this.bigdataId,"02");
        this.$refs.modalForm.title="新增";
        this.$refs.modalForm.disableSubmit = false;
        
      },
      modalFormDataListOk(){
        
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>